import type { GuestInfo } from '@entities/leadCollector';

export const copyGuestWithNewIds = (template: GuestInfo): GuestInfo => {
  const newGuest = structuredClone(template);
  newGuest.FIO = (newGuest.FIO ?? []).map((v) => ({
    ...v,
    instanceId: `${Date.now()}-${Math.random()}`,
    value: '',
    error: '',
  }));
  newGuest.additionalFields = (newGuest.additionalFields ?? []).map((v) => ({
    ...v,
    instanceId: `${Date.now()}-${Math.random()}`,
    value: '',
    error: '',
  }));
  return newGuest;
};
